import { Injectable } from '@angular/core';

@Injectable()
export class TableHeaderService {
  currentSortedColumn: string = '';
  direction: string = '';

  constructor() { }

  sortColumn(column: string) : string[] {
    if (this.currentSortedColumn !== column) {
      this.currentSortedColumn = column;
      this.direction = 'down';
    } else this.direction = this.direction === 'up' ? 'down' : 'up';
    return [this.currentSortedColumn, this.direction];
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/table-header/table-header.service.ts